import React, { useState } from 'react';
import Card from '../../components/Card';
import Modal from '../../components/Modal';
import { KVKK_CONTENT } from '../../utils/constants';
import style from './footer.module.scss';

const Footer = () => {
	const [isKvkkModalOpen, setIsKvkkModalOpen] = useState(false);

	return (
		<>
			<Card className={style.container} customContentClass={style.content}>
				<a onClick={() => setIsKvkkModalOpen(true)}>
					<span>KVKK Aydınlatma Metni</span>
				</a>
				<span>Logo Yazılım A.Ş.</span>
			</Card>
			<Modal content={KVKK_CONTENT} isOpen={isKvkkModalOpen} onClose={() => setIsKvkkModalOpen(false)} />
		</>
	);
};

export default Footer;
